import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    productdetail: {},
    tplData: {},
    httpCodes: {
      productdetail: null,
      tplData: null
    },
    actFooter: {},
    localEligData: [],
    productDetailSrc: process.env.URL_PRODUCTDETAIL || "/pb/easy-api/servicedata",
    travelDetailSrc: process.env.URL_TRAVELDETAIL || "/pb/easy-api/traveldata",
    tplSrc: process.env.URL_STATIC || "/pb/easy-api/static",
    elgSrc: process.env.URL_ELIGIBLE || "/pb/easy-api/eligible",
    // productDetailSrc: "js/productdetail.json",
    // travelDetailSrc: "js/traveldetail.json",
    // tplSrc: "//m2.telekom.sk/pb/easy-api/static",
    // elgSrc: "js/eligible.json",
    reloadSrc: "/pb/easy-api/reload-amount/",
    activeAnalytic: false,
    headerShown: true,
    isAres: true,
    forceOverride: false,
    globalOldRpln: false,
    onlyMixPkg: false
  },

  getters: {
  },
  
  mutations: {
    updateProductDetail(state, payload) {
      state.productdetail = payload
    },
    updateTplData(state, payload) {
      state.tplData = payload
    },
    httpProductDetail(state, payload) {
      state.httpCodes.productdetail = payload
    },
    httpTplData(state, payload) {
      state.httpCodes.tplData = payload
    },
    localEligData(state, payload) {
      state.localEligData = payload
    },
    setAres(state, payload) {
      state.isAres = payload
    },
    headerHide(state, payload) {
      state.headerShown = payload
    },
    setOverride(state, payload) {
      state.forceOverride = payload
    },
    setOldRpln(state, payload) {
      state.globalOldRpln = payload
    },
    updateOnlyMixPkg(state, payload) {
      state.onlyMixPkg = payload;
    }
  },
  actions: {
    refreshProductDetail(context) {
      var that = this
      return new Promise((resolve) => {
        axios.get(that.state.productDetailSrc).then((response) => {
          context.commit('updateProductDetail', response.data);
          context.commit('httpProductDetail', response.status);
          }).catch((e) => {
            context.commit('httpProductDetail', e.response.status);
          }).finally(() => {
            resolve() 
          });
      });
    },    
    refreshProductDetailRplnChange(context, inQuery) {
      var that = this
      return new Promise((resolve) => {
        axios.get(that.state.productDetailSrc, { params: inQuery, headers: { 'x-check-rplncontrol': '1' } }).then((response) => {
          context.commit('updateProductDetail', response.data);
          context.commit('httpProductDetail', response.status);
          }).catch((e) => {
            context.commit('httpProductDetail', e.response.status);
          }).finally(() => {
            resolve() 
          });
      });
    },    
    refreshTplData(context) {
      var that = this
      return new Promise((resolve) => {
        axios.get(that.state.tplSrc).then((response) => {
            context.commit('updateTplData', response.data);
            context.commit('httpTplData', response.status);
          }).catch((e) => {
            if (e.response) {
              context.commit('httpTplData', e.response.status);
            }
          }).finally(() => {
            resolve() 
          });
      });
    },    
  },
  modules: {
  }
})

